export function renderedRemotely(element: HTMLElement | undefined) {
    if (!element) {
        return true;
    }

    return element.dataset.renderedRemotely !== undefined;
}
